import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
interface AnimeCardProps {
  title: string;
  image: string;
  match: number;
  episodes: string;
  genres: string[];
  delay?: number;
}
export function AnimeCard({
  title,
  image,
  match,
  episodes,
  genres,
  delay = 0
}: AnimeCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.5,
    ease: 'easeOut'
  }} className="relative group cursor-pointer" data-id="element-19">
      {/* Glow effect behind card */}
      <div className="absolute -inset-1 bg-rose-500/20 blur-xl rounded-2xl opacity-0 group-hover:opacity-100 transition duration-700 pointer-events-none" data-id="element-20" />

      <div className="relative aspect-[21/9] md:aspect-[16/9] lg:aspect-[21/9] rounded-2xl overflow-hidden bg-dark border border-white/5 group-hover:border-rose-500/30 transition-colors duration-500" data-id="element-21">
        <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-22" />

        {/* Gradient overlays */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-90" data-id="element-23" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent opacity-80" data-id="element-24" />

        {/* Content */}
        <div className="absolute inset-0 p-6 flex flex-col justify-between" data-id="element-25">
          <div className="flex justify-between items-start" data-id="element-26">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-black/60 backdrop-blur-md border border-white/10 text-xs font-semibold text-rose-400" data-id="element-27">
              <span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" data-id="element-28" />
              {match}% Match
            </div>

            <div className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-id="element-29">
              <Play className="w-4 h-4 text-white fill-white ml-0.5" data-id="element-30" />
            </div>
          </div>

          <div data-id="element-31">
            <h3 className="text-2xl md:text-3xl font-serif text-white mb-2 group-hover:text-rose-100 transition-colors" data-id="element-32">
              {title}
            </h3>
            <div className="flex items-center gap-3 text-xs text-white/60 font-medium" data-id="element-33">
              <span data-id="element-34">{episodes}</span>
              <span className="w-1 h-1 rounded-full bg-white/20" data-id="element-35" />
              <div className="flex gap-2" data-id="element-36">
                {genres.map(genre => <span key={genre} data-id="element-37">{genre}</span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}